// Euclid Algorithm for the Greatest Common Divisor

function gcd2(a, b) {
  // Greatest common divisor of 2 integers
  if (!b) return b === 0 ? a : NaN;
  return gcd2(b, a % b);
}

function lcm2(a, b) {
  // Least common multiple of 2 integers
  return (a * b) / gcd2(a, b);
}

export function findLCM(array) {
  // Least common multiple of a list of integers
  let n = 1;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < array.length; ++i) {
    n = lcm2(array[i], n);
  }
  // can have weird behaviour beyond that
  return n > 1000 ? 1000 : n;
}
